"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsersGroup = void 0;

var tslib_1 = require("tslib");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importDefault(require("react"));

var UsersGroup = function UsersGroup() {
  var filterId = (0, use_id_1.useId)();
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("filter", {
    id: filterId,
    filterUnits: "objectBoundingBox"
  }, react_1.default.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "1 0 0 0 0.4\n     0 1 0 0 0.4\n     0 0 1 0 0.4\n     0 0 0 1 0"
  })), react_1.default.createElement("path", {
    filter: "url(#".concat(filterId, ")"),
    d: "M13.9338 13.5048H10.0673C6.09685 13.5048 4.68855 16.3994 4.68855 18.8781C4.68855 21.0794 5.91378 22.2906 8.13678 22.2906H15.8653C18.0883 22.2906 19.3136 21.0783 19.3136 18.8781C19.3125 16.4005 17.9042 13.5048 13.9338 13.5048Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M12.0087 11.4713C14.1126 11.4713 15.8231 9.76723 15.8231 7.67315C15.8231 5.57798 14.1115 3.875 12.0087 3.875C9.90598 3.875 8.19537 5.57906 8.19537 7.67315C8.19537 9.76723 9.90489 11.4713 12.0087 11.4713Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    filter: "url(#".concat(filterId, ")"),
    d: "M23.3749 12.7042C23.3749 14.3942 22.4432 15.3258 20.7424 15.3258H20.2875C20.1466 15.3258 20.0383 15.25 19.9841 15.1308C19.1933 13.7008 17.8608 12.5742 15.9433 12.1192C15.6941 12.0542 15.5858 11.7508 15.7699 11.5775C16.5174 10.8733 17.0591 9.95254 17.2975 8.92337C17.33 8.78254 17.46 8.67422 17.6117 8.67422H19.3558C22.3242 8.67422 23.3749 10.8517 23.3749 12.7042Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M20.8618 4.60088C20.8618 6.20421 19.5617 7.50414 17.9692 7.50414C17.889 7.50414 17.8099 7.4998 17.733 7.4933C17.6334 7.48463 17.5598 7.45222 17.5099 7.39914C17.4601 7.34606 17.4319 7.29514 17.4254 7.21281C17.3095 5.74923 16.6021 4.45454 15.5415 3.56079C15.4754 3.50446 15.4428 3.46659 15.4266 3.39509C15.4114 3.32684 15.4092 3.24881 15.4493 3.17623C15.9455 2.29981 16.888 1.70728 17.9692 1.70728C19.5617 1.70836 20.8618 3.00838 20.8618 4.60088Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    filter: "url(#".concat(filterId, ")"),
    d: "M0.625 12.7042C0.625 14.3942 1.55672 15.3258 3.25756 15.3258H3.71247C3.85331 15.3258 3.96167 15.25 4.01584 15.1308C4.80667 13.7008 6.13915 12.5742 8.05665 12.1192C8.30582 12.0542 8.41419 11.7508 8.23002 11.5775C7.48252 10.8733 6.94082 9.95254 6.70248 8.92337C6.66998 8.78254 6.53994 8.67422 6.38827 8.67422H4.64412C1.67579 8.67422 0.625 10.8517 0.625 12.7042Z",
    fill: "currentColor"
  }), react_1.default.createElement("path", {
    d: "M3.13828 4.60088C3.13828 6.20421 4.43832 7.50414 6.03082 7.50414C6.11099 7.50414 6.19009 7.4998 6.26701 7.4933C6.36668 7.48463 6.44027 7.45222 6.4901 7.39914C6.53994 7.34606 6.56811 7.29514 6.57461 7.21281C6.69052 5.74923 7.39795 4.45454 8.45854 3.56079C8.52462 3.50446 8.55721 3.46659 8.57346 3.39509C8.58862 3.32684 8.59079 3.24881 8.55071 3.17623C8.05454 2.29981 7.11199 1.70728 6.03082 1.70728C4.43832 1.70836 3.13828 3.00838 3.13828 4.60088Z",
    fill: "currentColor"
  }));
};

exports.UsersGroup = UsersGroup;